export default (props, vars) =>
  props?.['student']?.university
    ? `${props?.['student'].university}${
        props?.['student'].grad_year ? `, ${props?.['student'].grad_year}` : ''
      }`
    : '—';
